import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Menu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (route: string) => {
    navigate(route);
    setIsOpen(false);
  };

  return (
    <div className="relative z-50 font-frankbook">
      {/* Menu Icon */}
      <svg
        className="w-8 h-8 text-orange absolute top-8 right-8 cursor-pointer"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 400 400"
        onClick={handleToggleDropdown}
      >
        <path d="M391.6,85.5c-0.5,0.9-1.1,1.8-1.4,2.8c-3.5,9.5-12.1,15.7-22.3,15.9c-0.1,0-0.2,0-0.4,0c-111.8,0-223.5,0-335.3,0 c-11.6,0-21-7.9-23.4-19.3c-2.9-14,7.6-27.7,21.9-28.5c1.5-0.1,3-0.1,4.5-0.1c109.5,0,219,0.1,328.5-0.1c13.5,0,24.4,6.3,27.5,19.5 c0,0.1,0.2,0.1,0.3,0.1C391.6,79.1,391.6,82.3,391.6,85.5z" />
        <path d="M391.6,205.3c-0.5,0.9-1.1,1.8-1.4,2.8c-3.5,9.5-12.1,15.7-22.3,15.9c-0.2,0-0.5,0-0.7,0c-111.5,0-223,0-334.5,0 c-11.9,0-21.3-7.8-23.8-19.3c-2.9-14,7.6-27.7,21.9-28.5c1.5-0.1,3-0.1,4.5-0.1c109.5,0,219,0.1,328.5-0.1 c13.5,0,24.4,6.3,27.5,19.5c0,0.1,0.2,0.1,0.3,0.1C391.6,198.8,391.6,202.1,391.6,205.3z" />
        <path d="M391.6,325.1c-0.5,0.9-1.1,1.8-1.4,2.8c-3.5,9.5-12.1,15.7-22.3,15.9c-0.2,0-0.5,0-0.7,0c-111.5,0-223,0-334.5,0 c-11.9,0-21.3-7.8-23.8-19.3c-2.9-14,7.6-27.7,21.9-28.5c1.5-0.1,3-0.1,4.5-0.1c109.5,0,219,0.1,328.5-0.1 c13.5,0,24.4,6.3,27.5,19.5c0,0.1,0.2,0.1,0.3,0.1C391.6,318.6,391.6,321.8,391.6,325.1z" />
      </svg>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-8 top-16 bg-darkGray shadow-lg w-32">
          <ul className="space-y-2 p-4">
            <li>
              <button
                className="w-full text-right text-white hover:text-lightOrange py-1"
                onClick={() => handleNavigation("/")}
              >
                Home
              </button>
            </li>
            <li>
              <button
                className="w-full text-right text-white hover:text-lightOrange py-1"
                onClick={() => handleNavigation("/leightons")}
              >
                Leightons
              </button>
            </li>
            <li>
              <button
                className="w-full text-right text-white hover:text-lightOrange py-1"
                onClick={() => handleNavigation("/kane-fm")}
              >
                Kane FM
              </button>
            </li>
            <li>
              <button
                className="w-full text-right text-white hover:text-lightOrange py-1"
                onClick={() => handleNavigation("/archer-arts")}
              >
                Archer Arts
              </button>
            </li>
            <li>
              <button
                className="w-full text-right text-white hover:text-lightOrange py-1"
                onClick={() => handleNavigation("/powerhouse")}
              >
                Powerhouse
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Menu;
